import type { PlaybookViewDefaults } from "@repo/app-types/entities/playbookViewDefaults";

interface AvailableColumnIds {
  metric_column_ids: ReadonlySet<string>;
  section_column_ids: ReadonlySet<string>;
  custom_field_column_ids: ReadonlySet<string>;
}

const columnIdKeys = [
  "metric_column_ids",
  "section_column_ids",
  "custom_field_column_ids",
] as const;

/** Only changed column defaults; undefined means there is nothing to save. */
export function buildPlaybookViewColumnDefaultsPatch(
  selected: PlaybookViewDefaults,
  stored: PlaybookViewDefaults | undefined,
  available: AvailableColumnIds,
): PlaybookViewDefaults | undefined {
  const patch: PlaybookViewDefaults = {};
  for (const key of columnIdKeys) {
    const selectedIds = selected[key];
    if (selectedIds === undefined) continue;

    const availableIds = available[key];
    const defaultIds =
      stored?.[key] ?? (key === "metric_column_ids" ? [...availableIds] : []);
    const selectedVisibleIds = new Set(
      selectedIds.filter((id) => availableIds.has(id)),
    );
    const defaultVisibleIds = new Set(
      defaultIds.filter((id) => availableIds.has(id)),
    );
    if (
      selectedVisibleIds.size !== defaultVisibleIds.size ||
      [...selectedVisibleIds].some((id) => !defaultVisibleIds.has(id))
    ) {
      // Keep preserved columns from other surfaces, such as Goal progress.
      patch[key] = selectedIds;
    }
  }

  if (
    selected.playbook_column_visible !== undefined &&
    selected.playbook_column_visible !==
      (stored?.playbook_column_visible ?? true)
  ) {
    patch.playbook_column_visible = selected.playbook_column_visible;
  }

  return Object.keys(patch).length > 0 ? patch : undefined;
}
